import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App.jsx";
import { registerServiceWorker } from "./registerServiceWorker.js";
import "./styles/app.css";

function ensureEmbedStylesheet() {
  if (import.meta.env.DEV) return;

  const href = new URL(/* @vite-ignore */ "embed.css", import.meta.url).href;
  const existingStylesheet = Array.from(document.querySelectorAll('link[rel="stylesheet"]')).some((link) => {
    return link.href === href || link.href.endsWith("/embed.css");
  });

  if (existingStylesheet) return;

  const link = document.createElement("link");
  link.rel = "stylesheet";
  link.href = href;
  link.crossOrigin = "anonymous";
  document.head.appendChild(link);
}

ensureEmbedStylesheet();

const rootId = window.__QUINIELA_CM_ROOT_ID__ || import.meta.env.VITE_ROOT_ID || "quiniela-cm-root";
let rootElement = document.getElementById(rootId);

if (!rootElement) {
  rootElement = document.createElement("div");
  rootElement.id = rootId;
  document.body.appendChild(rootElement);
}

createRoot(rootElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

registerServiceWorker();
